import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";

export interface DteTypeConfiguration {
	invoiceType: InvoiceType;
	primaryCodigoSii: number;
	codigosSii: number[];
	nombre: string;
	mostrarTransporte: boolean;
	rutaMantenedor: string;
}

const CONFIGURACIONES_DTE: { [key: number]: DteTypeConfiguration } = {
	[InvoiceType.Factura]: {
		invoiceType: InvoiceType.Factura,
		primaryCodigoSii: 33,
		codigosSii: [33, 34],
		nombre: "Factura Electrónica",
		mostrarTransporte: true,
		rutaMantenedor: "ventas/documentos-emitidos",
	},
	[InvoiceType.Boleta]: {
		invoiceType: InvoiceType.Boleta,
		primaryCodigoSii: 39,
		codigosSii: [39, 41],
		nombre: "Boleta Electrónica",
		mostrarTransporte: false,
		rutaMantenedor: "ventas/documentos-emitidos",
	},
	[InvoiceType.GuiaDespacho]: {
		invoiceType: InvoiceType.GuiaDespacho,
		primaryCodigoSii: 52,
		codigosSii: [52],
		nombre: "Guía de Despacho Electrónica",
		mostrarTransporte: true,
		rutaMantenedor: "ventas/guias-despacho",
	},
	[InvoiceType.FacturaCompra]: {
		invoiceType: InvoiceType.FacturaCompra,
		primaryCodigoSii: 46,
		codigosSii: [46],
		nombre: "Factura de Compra Electrónica",
		mostrarTransporte: false,
		rutaMantenedor: "compras/facturas-compras",
	},
	[InvoiceType.FacturaExportacion]: {
		invoiceType: InvoiceType.FacturaExportacion,
		primaryCodigoSii: 110,
		codigosSii: [110],
		nombre: "Factura de Exportación Electrónica",
		mostrarTransporte: false,
		rutaMantenedor: "ventas/exportaciones",
	},
	[InvoiceType.LiquidacionFactura]: {
		invoiceType: InvoiceType.LiquidacionFactura,
		primaryCodigoSii: 43,
		codigosSii: [43],
		nombre: "Liquidación de Factura Electrónica",
		mostrarTransporte: false,
		rutaMantenedor: "ventas/documentos-emitidos",
	},
	[InvoiceType.NotaDebito]: {
		invoiceType: InvoiceType.NotaDebito,
		primaryCodigoSii: 56,
		codigosSii: [56],
		nombre: "Nota de Débito Electrónica",
		mostrarTransporte: false,
		rutaMantenedor: "ventas/documentos-emitidos",
	},
	[InvoiceType.NotaCredito]: {
		invoiceType: InvoiceType.NotaCredito,
		primaryCodigoSii: 61,
		codigosSii: [61],
		nombre: "Nota de Crédito Electrónica",
		mostrarTransporte: false,
		rutaMantenedor: "ventas/documentos-emitidos",
	},
};

const NOMBRES_POR_CODIGO_SII: { [codigo: number]: string } = {
	33: "Factura Electrónica",
	34: "Factura Electrónica Exenta",
	39: "Boleta Electrónica",
	41: "Boleta Electrónica Exenta",
	43: "Liquidación de Factura Electrónica",
	46: "Factura de Compra Electrónica",
	52: "Guía de Despacho Electrónica",
	56: "Nota de Débito Electrónica",
	61: "Nota de Crédito Electrónica",
	110: "Factura de Exportación Electrónica",
};

export function obtenerConfiguracionDte(invoiceType: InvoiceType): DteTypeConfiguration {
	return CONFIGURACIONES_DTE[invoiceType] || CONFIGURACIONES_DTE[InvoiceType.Factura];
}

export function obtenerNombreDtePorCodigo(codigoTipoDte: number): string {
	return NOMBRES_POR_CODIGO_SII[codigoTipoDte] || "Documento Electrónico";
}
